import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { FastField, Field, useFormikContext } from "formik";
import { TextField } from "@mui/material";
import DropdownSelector from "../../atoms/Common/DropdownSelector.tsx";
import { getCatalogue } from "../../api/common/catalogues.ts";

export default function ProductTintasForm() {
  const { values, setFieldValue } = useFormikContext() as any;

  // Initialize props structure for TINTAS products
  useEffect(() => {
    if (!values.props || values.props.length === 0 || 
        !values.props.some(p => p?.key === "F" || p?.key === "C" || p?.key === "S" || p?.key === "U")) {
      const props = [
        { key: "F", value: "XXX" }, // Acabado
        { key: "C", value: "XXX" }, // Color
        { key: "S", value: "" }, // Especificacion
        { key: "U", value: "" }, // Unidad de medida
      ];
      setFieldValue("props", props);
    }
  }, [setFieldValue, values.props]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.0.value"
          label="Acabado"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "PRODUCT_FINISH" }}
          keyField="id"
        />
      </Grid>

      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.1.value"
          label="Color"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "PRODUCT_COLOR", pageSize: 1000 }}
          keyField="id"
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.2.value"
          label="Especificación"
          as={TextField}
        />
      </Grid>

      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.3.value"
          label="Unidad de medida"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "UNIT" }}
          keyField="id"
        />
      </Grid>
    </Grid>
  );
}

